export default class TipoSolicitacaoFormularioModel {
  constructor({
    tipoSolicitacaoId = 0,
    formularioId = 0,
    visivelSolicitante = false,
    editavelSolicitante = false,
    visivelAgente = false,
    editavelAgente = false,
    visivelSolicitanteImpressao = false,
    visivelAgenteImpressao = false,
  } = {}) {
    this.tipoSolicitacaoId = tipoSolicitacaoId
    this.formularioId = formularioId
    this.visivelSolicitante = visivelSolicitante
    this.editavelSolicitante = editavelSolicitante
    this.visivelAgente = visivelAgente
    this.editavelAgente = editavelAgente
    this.visivelAgenteImpressao = visivelAgenteImpressao
    this.visivelSolicitanteImpressao = visivelSolicitanteImpressao
  }
}
